export default function LoadingSkeleton({ displayType }: { displayType: string }) {
  if (displayType === 'grid') {
    return (
      <div className="w-full overflow-hidden max-h-screen overflow-y-auto rounded-md grid grid-cols-2 gap-4">
            <div className="rounded-md p-4 border border-slate-200 bg-white flex flex-col relative animate-pulse">
          <div className="flex gap-4 flex-col items-center w-full justify-center ">
            <div className="h-20 w-full bg-slate-200 top-0 z-0 absolute"></div>
            <div className="h-20 w-20 rounded-full overflow-hidden  border border-slate-200 bg-white z-10"></div>
            <div className="text-center">
            <div className="h-4 bg-slate-200 w-24 rounded mt-2"></div>
              <div className="h-2 bg-slate-200 w-12 rounded mt-2"></div>
              <div className="h-2 bg-slate-200 w-24 rounded mt-2"></div>
            </div>
          </div>
          <div className="text-center flex items-center justify-center w-full">
            <div className="h-8 bg-slate-200 w-1/2 rounded mt-4"></div>
          </div>
        </div>
            <div className="rounded-md p-4 border border-slate-200 bg-white flex flex-col relative animate-pulse">
          <div className="flex gap-4 flex-col items-center w-full justify-center ">
            <div className="h-20 w-full bg-slate-200 top-0 z-0 absolute"></div>
            <div className="h-20 w-20 rounded-full overflow-hidden  border border-slate-200 bg-white z-10"></div>
            <div className="text-center">
            <div className="h-4 bg-slate-200 w-24 rounded mt-2"></div>
              <div className="h-2 bg-slate-200 w-12 rounded mt-2"></div>
              <div className="h-2 bg-slate-200 w-24 rounded mt-2"></div>
            </div>
          </div>
          <div className="text-center flex items-center justify-center w-full">
            <div className="h-8 bg-slate-200 w-1/2 rounded mt-4"></div>
          </div>
        </div>
            <div className="rounded-md p-4 border border-slate-200 bg-white flex flex-col relative animate-pulse">
          <div className="flex gap-4 flex-col items-center w-full justify-center ">
            <div className="h-20 w-full bg-slate-200 top-0 z-0 absolute"></div>
            <div className="h-20 w-20 rounded-full overflow-hidden  border border-slate-200 bg-white z-10"></div>
            <div className="text-center">
            <div className="h-4 bg-slate-200 w-24 rounded mt-2"></div>
              <div className="h-2 bg-slate-200 w-12 rounded mt-2"></div>
              <div className="h-2 bg-slate-200 w-24 rounded mt-2"></div>
            </div>
          </div>
          <div className="text-center flex items-center justify-center w-full">
            <div className="h-8 bg-slate-200 w-1/2 rounded mt-4"></div>
          </div>
        </div>
            <div className="rounded-md p-4 border border-slate-200 bg-white flex flex-col relative animate-pulse">
          <div className="flex gap-4 flex-col items-center w-full justify-center ">
            <div className="h-20 w-full bg-slate-200 top-0 z-0 absolute"></div>
            <div className="h-20 w-20 rounded-full overflow-hidden  border border-slate-200 bg-white z-10"></div>
            <div className="text-center">
            <div className="h-4 bg-slate-200 w-24 rounded mt-2"></div>
              <div className="h-2 bg-slate-200 w-12 rounded mt-2"></div>
              <div className="h-2 bg-slate-200 w-24 rounded mt-2"></div>
            </div>
          </div>
          <div className="text-center flex items-center justify-center w-full">
            <div className="h-8 bg-slate-200 w-1/2 rounded mt-4"></div>
          </div>
        </div>
            <div className="rounded-md p-4 border border-slate-200 bg-white flex flex-col relative animate-pulse">
          <div className="flex gap-4 flex-col items-center w-full justify-center ">
            <div className="h-20 w-full bg-slate-200 top-0 z-0 absolute"></div>
            <div className="h-20 w-20 rounded-full overflow-hidden  border border-slate-200 bg-white z-10"></div>
            <div className="text-center">
            <div className="h-4 bg-slate-200 w-24 rounded mt-2"></div>
              <div className="h-2 bg-slate-200 w-12 rounded mt-2"></div>
              <div className="h-2 bg-slate-200 w-24 rounded mt-2"></div>
            </div>
          </div>
          <div className="text-center flex items-center justify-center w-full">
            <div className="h-8 bg-slate-200 w-1/2 rounded mt-4"></div>
          </div>
        </div>
            <div className="rounded-md p-4 border border-slate-200 bg-white flex flex-col relative animate-pulse">
          <div className="flex gap-4 flex-col items-center w-full justify-center ">
            <div className="h-20 w-full bg-slate-200 top-0 z-0 absolute"></div>
            <div className="h-20 w-20 rounded-full overflow-hidden  border border-slate-200 bg-white z-10"></div>
            <div className="text-center">
            <div className="h-4 bg-slate-200 w-24 rounded mt-2"></div>
              <div className="h-2 bg-slate-200 w-12 rounded mt-2"></div>
              <div className="h-2 bg-slate-200 w-24 rounded mt-2"></div>
            </div>
          </div>
          <div className="text-center flex items-center justify-center w-full">
            <div className="h-8 bg-slate-200 w-1/2 rounded mt-4"></div>
          </div>
        </div>
            <div className="rounded-md p-4 border border-slate-200 bg-white flex flex-col relative animate-pulse">
          <div className="flex gap-4 flex-col items-center w-full justify-center ">
            <div className="h-20 w-full bg-slate-200 top-0 z-0 absolute"></div>
            <div className="h-20 w-20 rounded-full overflow-hidden  border border-slate-200 bg-white z-10"></div>
            <div className="text-center">
            <div className="h-4 bg-slate-200 w-24 rounded mt-2"></div>
              <div className="h-2 bg-slate-200 w-12 rounded mt-2"></div>
              <div className="h-2 bg-slate-200 w-24 rounded mt-2"></div>
            </div>
          </div>
          <div className="text-center flex items-center justify-center w-full">
            <div className="h-8 bg-slate-200 w-1/2 rounded mt-4"></div>
          </div>
        </div>
        <div className="rounded-md p-4 border border-slate-200 bg-white flex flex-col relative animate-pulse">
          <div className="flex gap-4 flex-col items-center w-full justify-center ">
            <div className="h-20 w-full bg-slate-200 top-0 z-0 absolute"></div>
            <div className="h-20 w-20 rounded-full overflow-hidden  border border-slate-200 bg-white z-10"></div>
            <div className="text-center">
              <div className="h-4 bg-slate-200 w-24 rounded mt-2"></div>
              <div className="h-4 bg-slate-200 w-12 rounded mt-2"></div>
              <div className="h-4 bg-slate-200 w-24 rounded mt-2"></div>
            </div>
          </div>
          <div className="text-center">
            <div className="h-4 bg-slate-200 w-1/2 rounded mt-2"></div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="w-full overflow-hidden flex flex-col divide-y bg-white divide-slate-200 rounded-md border border-slate-200 animate-pulse">
      <div className="p-4 flex">
        <div className="flex w-full">
          <div className="h-10 w-10 bg-slate-200 rounded-full mr-4"></div>
          <div className="flex-1 gap-y-3 flex flex-col w-full">
            <div className="h-4 bg-slate-200 rounded w-24"></div>
            <div className="h-2 bg-slate-200 rounded w-16"></div>
            <div className="h-2 bg-slate-200 rounded w-16"></div>
          </div>
        </div>
      </div>
      <div className="p-4 flex">
        <div className="flex">
          <div className="h-10 w-10 bg-slate-200 rounded-full mr-4"></div>
          <div className="flex-1 gap-y-3 flex flex-col w-full">
            <div className="h-4 bg-slate-200 rounded w-24"></div>
            <div className="h-2 bg-slate-200 rounded w-16"></div>
            <div className="h-2 bg-slate-200 rounded w-16"></div>
          </div>
        </div>
      </div>
      <div className="p-4 flex">
        <div className="flex">
          <div className="h-10 w-10 bg-slate-200 rounded-full mr-4"></div>
          <div className="flex-1 gap-y-3 flex flex-col">
            <div className="h-4 bg-slate-200 rounded w-24"></div>
            <div className="h-2 bg-slate-200 rounded w-16"></div>
            <div className="h-2 bg-slate-200 rounded w-16"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
